module.exports = "/build/admin/images/largetile.f49a7451.png";